import { useCallback, useEffect, useState } from 'react'

import { subscibeTo, useDataBoxSelector } from 'app/common/data-box-store'
import { PlainRadioGroup } from 'app/common/ui-next/plain-radio-button'
import {
  customerTypeFilterSelection,
  financesSummaryGroupFilter,
  financesSummaryGroupFilterSelection,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'
import { CustomerType } from 'app/dataTypes/reports/customersType'

type Props = {
  id: string
  pending: boolean
}

export const FinancesSummaryGroupFilter = ({ id, pending }: Props) => {
  const [isCustomerTypeReady, setReadyCustomerType] = useState<boolean>(false)
  const [isStudentListReady, setReadyStudentList] = useState<boolean>(true)
  const data = useDataBoxSelector(financesSummaryGroupFilter, () => financesSummaryGroupFilter.data)
  const current = useDataBoxSelector(
    financesSummaryGroupFilterSelection,
    () => financesSummaryGroupFilterSelection.data,
  )

  const handleChange = useCallback((value: string) => {
    financesSummaryGroupFilterSelection.updateData(() => value)
  }, [])

  const handleCustomerTypeFilter = useCallback((data: string[]) => {
    if (data.length === 1 && data[0] === CustomerType.Students) {
      setReadyCustomerType(true)
      return
    }
    setReadyCustomerType(false)
  }, [])

  const handleStudentListFilter = useCallback((data: string[]) => {
    if (data.length === 0) {
      setReadyStudentList(true)
      return
    }
    setReadyStudentList(false)
  }, [])

  useEffect(() => {
    const customerTypeFilterUnsubsribe = subscibeTo<string[]>(
      customerTypeFilterSelection.id,
      handleCustomerTypeFilter,
    )
    const studentsListFilterUnsubsribe = subscibeTo<string[]>(
      studentListFilterSelection.id,
      handleStudentListFilter,
    )
    return () => {
      customerTypeFilterUnsubsribe()
      studentsListFilterUnsubsribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isStudentListReady &&
    isCustomerTypeReady && (
      <>
        <PlainRadioGroup
          id={id}
          label="Группировать по"
          items={data}
          current={current}
          disabled={pending}
          onChange={handleChange}
          keepPadding
        />
      </>
    )
  )
}
